// The variable process.env.NODE_ENV
// is set to 'production' when running `npm run build`
// but set to 'development' when running `npm start`
const production_environment = process.env.NODE_ENV === 'production';

// Determine which stage we're deploying to
const stage = process.env.DEPLOY_STAGE || 'dev';

// Backend URLs by stage
const backendUrls = {
	dev: {
		publicApi: 'https://api.dev.tuutuum.se',
	},
	prod: {
		publicApi: 'https://api.tuutuum.se',
	},
};

const config = {
	// In development (local), always use dev backend
	// In production (deployed), use the stage-specific backend
	TUUTUUM_BACKEND_PUBLIC_API: production_environment 
		? backendUrls[stage].publicApi 
		: backendUrls.dev.publicApi,
	// In local dev, use localhost.tuutuum.se domain to enable cookie sharing between sites
	// (requires adding "127.0.0.1 localhost.tuutuum.se public.localhost.tuutuum.se" to /etc/hosts)
	ADMIN_REROUTE: production_environment 
		? (stage === 'prod' ? 'https://tuutuum.se/register_qr_code' : 'https://dev.tuutuum.se/register_qr_code')
		: 'http://localhost.tuutuum.se:9001/register_qr_code'
};

export default config;
